import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { machineCatalogRoutes } from './machine-catalog.routes';
import { provideMachineCatalogGlobals } from './machine-catalog.globals';

export function provideMachineCatalog() {
  return [
    provideSoftAppsModule(
      {
        name: 'machine-catalog',
        title: '#MACHINE_CATALOG.TITLE',
        icon: 'fa-regular fa-tractor',
        route: '/machine-catalog/search',
        color: 'bg-accent text-white',
        group: getModuleGroupById(11),
        permission: 'SOFTAPPS.GARAGE_MACHINE',
      },
      withSoftAppsModuleRoutes({ app: machineCatalogRoutes }),
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleInfo({
        library: '@softapps/werkstatt/machine-catalog',
        description: 'Maschinenkatalog der Werkstatt durchsuchen.',
      })
    ),
    ...provideMachineCatalogGlobals(),
  ];
}
